/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    BridgeApiAttachment,
    BridgeApiAttachmentFromJSON,
    BridgeApiAttachmentToJSON,
} from '../models';

export interface DownloadAttachmentRequest {
    attachmentId: string;
}

export interface UploadMessageAttachmentRequest {
    file: Blob;
    conversationId?: string;
    counterpartiesIds?: Array<string>;
}

/**
 * 
 */
export class BridgeAttachmentApi extends runtime.BaseAPI {

    /**
     * Get attachment
     */
    async downloadAttachmentRaw(requestParameters: DownloadAttachmentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling downloadAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/messages/attachments/{attachmentId}`.replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get attachment
     */
    async downloadAttachment(requestParameters: DownloadAttachmentRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.downloadAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create attachment
     */
    async uploadMessageAttachmentRaw(requestParameters: UploadMessageAttachmentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiAttachment>> {
        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadMessageAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        if (requestParameters.conversationId !== undefined) {
            formParams.append('conversationId', requestParameters.conversationId as any);
        }

        if (requestParameters.counterpartiesIds) {
            formParams.append('counterpartiesIds', requestParameters.counterpartiesIds.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        const response = await this.request({
            path: `/v4/messages/attachments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiAttachmentFromJSON(jsonValue));
    }

    /**
     * Create attachment
     */
    async uploadMessageAttachment(requestParameters: UploadMessageAttachmentRequest, initOverrides?: RequestInit): Promise<BridgeApiAttachment> {
        const response = await this.uploadMessageAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
